import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import DeleteDialog from "./DeleteDialog";
import { useDispatch } from "react-redux";
import { deleteServiceById } from "../../actions/userAuth";
import { enqueueSnackbar } from "notistack";

const DeleteConfirmationDialog = ({ id, addDeactivation, setAddDeactivation, deleteDialog, setDeleteDialog }) => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const closeHandler = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setAddDeactivation(false)
    };

    const handleDeleteService = () => {
        setLoading(true);
        dispatch(deleteServiceById(id, { }, (data) => {
            setLoading(false);
            setAddDeactivation(false);
            setDeleteDialog(true);
        }, (err) => {
            setLoading(false);
            enqueueSnackbar("Error Occured! please try again", { variant: "error" });
        }));
    }
    return (
        <>
            <Dialog
                open={addDeactivation}
                onClose={closeHandler}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CloseIcon sx={{ float: 'right', cursor: 'pointer', marginLeft: 'auto' }} onClick={closeHandler} />
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center' }}>
                    <Box sx={{ py: 1.5 }}>
                        <Typography className="subHeading1Bold" sx={{ marginLeft: 'auto' }}>Do You Want To Delete Your service?</Typography>
                        <Typography className="text1Mid" sx={{ py: 1 }}>
                            (The service will Deactivated For new Candidates But Will be Deleted After finishing Services Existing Candidates.)
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', backgroundColor: '#2544EE' }}>
                    <Button className="text1Mid" sx={{ color: '#000', background: '#FFF', px: 5 }} onClick={closeHandler}>No</Button>
                    <Button className="text1Mid" sx={{ color: '#FFF', px: 5, border: '1px solid #FFF' }} onClick={handleDeleteService} disabled={loading}>
                        {
                            loading
                                ?
                                <CircularProgress size={24} />
                                :
                                "Yes"
                        }
                    </Button>
                </DialogActions>
            </Dialog>
            <DeleteDialog
                deleteDialog={deleteDialog}
                setDeleteDialog={setDeleteDialog}
            />
        </>
    )
}

export default DeleteConfirmationDialog;